import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { Compliance } from '@/features/compliance'

export const Route = createFileRoute('/_authenticated/_organization/compliance/')({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: Compliance,
})
